var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap" },
    [
      _c(
        "el-form",
        {
          ref: "contForm",
          staticClass: "cont-form",
          attrs: { size: "small", model: _vm.contractInfo }
        },
        [
          _c(
            "div",
            { staticClass: "f-top" },
            [
              _c("el-form-item", [
                _c(
                  "div",
                  { staticStyle: { position: "relative" } },
                  [
                    _c("h4", [_c("i"), _vm._v("模板名称")]),
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          position: "absolute",
                          right: "20px",
                          top: "10px"
                        },
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.$router.back()
                          }
                        }
                      },
                      [_vm._v("返回")]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "el-form-item",
                {
                  staticClass: "s-er",
                  attrs: { prop: "tplName", rules: _vm.myRules.tplName }
                },
                [
                  _c(
                    "el-row",
                    { staticStyle: { width: "550px" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入模板名称" },
                        on: { blur: _vm.validContractName },
                        model: {
                          value: _vm.contractInfo.tplName,
                          callback: function($$v) {
                            _vm.$set(_vm.contractInfo, "tplName", $$v)
                          },
                          expression: "contractInfo.tplName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "f-top" },
            [
              _c("el-form-item", [_c("h4", [_c("i"), _vm._v("模板文件")])]),
              _c("el-form-item", [
                _c("div", { staticClass: "input-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "input-box" },
                    [
                      !_vm.contractFile.fileName
                        ? [
                            _c("span", { staticClass: "el-icon-plus" }),
                            _c("br"),
                            _c("p", [
                              _vm._v("上传docx/doc/pdf格式文件"),
                              _c("br"),
                              _vm._v("\n              大小不能超过20M")
                            ])
                          ]
                        : [
                            _c("div", { staticClass: "f-box" }, [
                              _c("div", { staticClass: "bx" }, [
                                _vm.fileSuffix(_vm.contractFile.fileName) ===
                                "pdf"
                                  ? _c("img", {
                                      attrs: {
                                        src: "/images/advancedVersion/pdf.png"
                                      }
                                    })
                                  : _vm._e(),
                                _vm.fileSuffix(_vm.contractFile.fileName) ===
                                  "doc" ||
                                _vm.fileSuffix(_vm.contractFile.fileName) ===
                                  "docx"
                                  ? _c("img", {
                                      attrs: {
                                        src: "/images/advancedVersion/word.png"
                                      }
                                    })
                                  : _vm._e(),
                                _c("div", { staticClass: "msk" }, [
                                  _c("a", { on: { click: _vm.reUpload } }, [
                                    _vm._v("重新上传")
                                  ])
                                ])
                              ]),
                              _c(
                                "p",
                                { attrs: { title: _vm.contractFile.fileName } },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.contractFile.fileName) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ],
                      _c("input", {
                        ref: "contractFileInput",
                        attrs: { type: "file" },
                        on: { change: _vm.contractFileUpload }
                      })
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "fj-wrap" },
                    [
                      _c("span", { staticClass: "fj-box" }, [
                        _c("span", {
                          staticClass: "icon-fj",
                          staticStyle: { "vertical-align": "text-bottom" }
                        }),
                        _vm._v(
                          "添加附属材料（" +
                            _vm._s(_vm.enclosureFiles.length) +
                            "/3)\n              "
                        ),
                        _c("input", {
                          ref: "attatchFileInput",
                          attrs: { type: "file" },
                          on: { change: _vm.handleAttatchFileUpload }
                        })
                      ]),
                      _c(
                        "el-tooltip",
                        {
                          attrs: { effect: "light", placement: "bottom-start" }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v("\n                支持任意格式文件；"),
                              _c("br"),
                              _vm._v("最多可添加3个附件，每个最大30M；"),
                              _c("br"),
                              _vm._v(
                                "为固定附属材料，模板使用人可添加，不可删除"
                              ),
                              _c("br"),
                              _vm._v(
                                "仅供参与方查阅，不用于签署\n              "
                              )
                            ]
                          ),
                          _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: {
                              "font-size": "16px",
                              "margin-left": "10px",
                              color: "#a1a1a1",
                              cursor: "pointer",
                              "margin-right": "50px"
                            }
                          })
                        ]
                      ),
                      _vm.enclosureFiles && _vm.enclosureFiles.length
                        ? [
                            _vm._l(_vm.enclosureFiles, function(item, index) {
                              return [
                                _c("span", { key: index, staticClass: "fj" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(_vm._s(item.fileName))
                                  ]),
                                  _c("span", {
                                    staticClass: "el-icon-error",
                                    on: {
                                      click: function($event) {
                                        return _vm.delAttatch(item, index)
                                      }
                                    }
                                  })
                                ])
                              ]
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ])
            ],
            1
          ),
          !this.$route.query.apiPdf
            ? _c(
                "div",
                { staticClass: "f-center" },
                [
                  _c("el-form-item", [
                    _c("div", { staticClass: "h4" }, [
                      _c("i"),
                      _vm._v("签署设置\n          "),
                      _c("div", { staticClass: "wp" }, [
                        _c(
                          "div",
                          { staticClass: "radio" },
                          [
                            _c("div", [
                              _c(
                                "div",
                                { ref: "step5" },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.contractInfo.orderFlag,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.contractInfo,
                                            "orderFlag",
                                            $$v
                                          )
                                        },
                                        expression: "contractInfo.orderFlag"
                                      }
                                    },
                                    [
                                      _c("b", [_vm._v("按顺序签名")]),
                                      _c("small", [
                                        _vm._v("/各方按顺序完成签署")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ]),
                            _c(
                              "el-button",
                              {
                                staticClass: "abtn",
                                staticStyle: {
                                  "margin-right": "20px",
                                  "margin-top": "-10px"
                                },
                                attrs: { type: "danger" },
                                on: {
                                  click: function($event) {
                                    return _vm.addSignerList()
                                  }
                                }
                              },
                              [_vm._v("添加签署方\n              ")]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticClass: "tab" },
                      [
                        _vm.signers && _vm.signers.length
                          ? _c(
                              "div",
                              { staticClass: "list-box" },
                              [
                                _c(
                                  "draggable",
                                  {
                                    attrs: {
                                      list: _vm.signers,
                                      options: {
                                        handle: ".icon-move_box",
                                        animation: 200,
                                        ghostClass: "ghost"
                                      },
                                      move: function() {
                                        return this$1.contractInfo.orderFlag
                                      }
                                    },
                                    on: {
                                      start: function($event) {
                                        _vm.dragging = true
                                      },
                                      end: function($event) {
                                        _vm.dragging = false
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "transition-group",
                                      { attrs: { type: "transition" } },
                                      [
                                        _vm._l(_vm.signers, function(item, i) {
                                          return [
                                            _c(
                                              "li",
                                              { key: i },
                                              [
                                                _c(
                                                  "el-form",
                                                  {
                                                    key: i,
                                                    ref: "contractListTab",
                                                    refInFor: true,
                                                    staticClass:
                                                      "contract-lit__tab",
                                                    attrs: {
                                                      model: item,
                                                      size: "small",
                                                      "data-signerAbc":
                                                        item.signerAbc
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        class: {
                                                          item: true,
                                                          "sign-item": true,
                                                          "i-drag":
                                                            _vm.contractInfo
                                                              .orderFlag
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  _vm
                                                                    .contractInfo
                                                                    .orderFlag,
                                                                expression:
                                                                  "contractInfo.orderFlag"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "icon-move_box"
                                                          },
                                                          [_c("i")]
                                                        ),
                                                        _c("div", {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.contractInfo
                                                                  .orderFlag,
                                                              expression:
                                                                "contractInfo.orderFlag"
                                                            }
                                                          ],
                                                          staticStyle: {
                                                            width: "10px",
                                                            "text-align":
                                                              "right"
                                                          }
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "user-type"
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.signerAbc
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col",
                                                            staticStyle: {
                                                              width: "135px"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "el-form-item",
                                                              [
                                                                _c(
                                                                  "el-select",
                                                                  {
                                                                    staticClass:
                                                                      "select",
                                                                    attrs: {
                                                                      value:
                                                                        item.fix,
                                                                      size:
                                                                        "small"
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        val
                                                                      ) {
                                                                        _vm.handleFixType(
                                                                          val,
                                                                          i
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-option",
                                                                      {
                                                                        attrs: {
                                                                          value: 1,
                                                                          label:
                                                                            "固定人员"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "el-option",
                                                                      {
                                                                        attrs: {
                                                                          value: 0,
                                                                          label:
                                                                            "模板发起人指定"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        !!item.fix
                                                          ? [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    display:
                                                                      "flex",
                                                                    "justify-content":
                                                                      "flex-start",
                                                                    flex: "1"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col",
                                                                      staticStyle: {
                                                                        width:
                                                                          "230px"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "el-form-item",
                                                                        {
                                                                          attrs: {
                                                                            prop:
                                                                              "emailOrMobile",
                                                                            rules:
                                                                              _vm
                                                                                .rulesTab
                                                                                .emailOrMobile
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "el-input",
                                                                            {
                                                                              attrs: {
                                                                                placeholder:
                                                                                  "签署方接收手机/邮箱"
                                                                              },
                                                                              on: {
                                                                                blur: function() {
                                                                                  ;(item.emailOrMobile = _vm.$utils.trim(
                                                                                    item.emailOrMobile
                                                                                  )),
                                                                                    _vm.getUserInfoBySelectTargetId(
                                                                                      item.emailOrMobile,
                                                                                      i
                                                                                    )
                                                                                }
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  item.emailOrMobile,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "emailOrMobile",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.emailOrMobile"
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "icon icon-btn_tels",
                                                                                  staticStyle: {
                                                                                    "background-size":
                                                                                      "contain",
                                                                                    cursor:
                                                                                      "pointer"
                                                                                  },
                                                                                  attrs: {
                                                                                    slot:
                                                                                      "suffix"
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.handleTelsClickOther(
                                                                                        item,
                                                                                        i
                                                                                      )
                                                                                    }
                                                                                  },
                                                                                  slot:
                                                                                    "suffix"
                                                                                }
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col",
                                                                      staticStyle: {
                                                                        width:
                                                                          "230px"
                                                                      }
                                                                    },
                                                                    [
                                                                      item.canSelectArray &&
                                                                      item
                                                                        .canSelectArray
                                                                        .length >
                                                                        1
                                                                        ? [
                                                                            _c(
                                                                              "el-form-item",
                                                                              [
                                                                                _c(
                                                                                  "el-select",
                                                                                  {
                                                                                    staticClass:
                                                                                      "select",
                                                                                    staticStyle: {
                                                                                      width:
                                                                                        "100%"
                                                                                    },
                                                                                    attrs: {
                                                                                      size:
                                                                                        "small"
                                                                                    },
                                                                                    on: {
                                                                                      change: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.handleSelectCorpAccount(
                                                                                          $event,
                                                                                          item
                                                                                        )
                                                                                      }
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        item.canSelectArrayIndex,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          item,
                                                                                          "canSelectArrayIndex",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "item.canSelectArrayIndex"
                                                                                    }
                                                                                  },
                                                                                  _vm._l(
                                                                                    item.canSelectArray,
                                                                                    function(
                                                                                      v,
                                                                                      vi
                                                                                    ) {
                                                                                      return _c(
                                                                                        "el-option",
                                                                                        {
                                                                                          key: vi,
                                                                                          attrs: {
                                                                                            value: vi,
                                                                                            label:
                                                                                              v.name
                                                                                          }
                                                                                        }
                                                                                      )
                                                                                    }
                                                                                  ),
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ]
                                                                        : [
                                                                            _c(
                                                                              "el-form-item",
                                                                              {
                                                                                attrs: {
                                                                                  prop:
                                                                                    "name",
                                                                                  rules:
                                                                                    _vm
                                                                                      .rulesTab
                                                                                      .name,
                                                                                  "show-message":
                                                                                    item.disabled !==
                                                                                    "disabled"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "el-input",
                                                                                  {
                                                                                    attrs: {
                                                                                      value:
                                                                                        item.name,
                                                                                      disabled:
                                                                                        item.disabled ===
                                                                                        "disabled",
                                                                                      placeholder:
                                                                                        "请输入签署方名称"
                                                                                    },
                                                                                    on: {
                                                                                      input: function(
                                                                                        val
                                                                                      ) {
                                                                                        item.name = val
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ]
                                                                    ],
                                                                    2
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col",
                                                                      staticStyle: {
                                                                        width:
                                                                          "70px"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "el-form-item",
                                                                        [
                                                                          _c(
                                                                            "el-select",
                                                                            {
                                                                              staticClass:
                                                                                "select",
                                                                              attrs: {
                                                                                disabled:
                                                                                  item.disabled ===
                                                                                  "disabled",
                                                                                size:
                                                                                  "small"
                                                                              },
                                                                              on: {
                                                                                change: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.handleSignUserType(
                                                                                    item
                                                                                  )
                                                                                }
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  item.userType,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "userType",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.userType"
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "el-option",
                                                                                {
                                                                                  attrs: {
                                                                                    value: 0,
                                                                                    label:
                                                                                      "个人"
                                                                                  }
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "el-option",
                                                                                {
                                                                                  attrs: {
                                                                                    value: 1,
                                                                                    label:
                                                                                      "企业"
                                                                                  }
                                                                                }
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  item.userType ===
                                                                  0
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "col",
                                                                          staticStyle: {
                                                                            width:
                                                                              "160px"
                                                                          }
                                                                        },
                                                                        [
                                                                          item.userType ===
                                                                          0
                                                                            ? _c(
                                                                                "el-form-item",
                                                                                {
                                                                                  staticClass:
                                                                                    "IDCard",
                                                                                  staticStyle: {
                                                                                    position:
                                                                                      "relative"
                                                                                  },
                                                                                  attrs: {
                                                                                    prop:
                                                                                      "identityNo",
                                                                                    rules:
                                                                                      item.disabled !==
                                                                                      "disabled"
                                                                                        ? _vm
                                                                                            .rulesTab
                                                                                            .IDCard
                                                                                        : {},
                                                                                    "show-message":
                                                                                      item.disabled !==
                                                                                      "disabled"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "el-input",
                                                                                    {
                                                                                      class: {
                                                                                        "no-padding": item.disabled
                                                                                          ? true
                                                                                          : false
                                                                                      },
                                                                                      attrs: {
                                                                                        disabled:
                                                                                          item.disabled ===
                                                                                          "disabled",
                                                                                        placeholder:
                                                                                          "请输入中国大陆18位身份证号码"
                                                                                      },
                                                                                      model: {
                                                                                        value:
                                                                                          item.identityNo,
                                                                                        callback: function(
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            item,
                                                                                            "identityNo",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                        expression:
                                                                                          "item.identityNo"
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                  item.ischange ===
                                                                                  1
                                                                                    ? _c(
                                                                                        "a",
                                                                                        {
                                                                                          staticClass:
                                                                                            "color-success amend-signator amend-tab__form",
                                                                                          attrs: {
                                                                                            href:
                                                                                              "javascript:void (0)"
                                                                                          },
                                                                                          on: {
                                                                                            click: function(
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.handleTargetIdChange(
                                                                                                item
                                                                                              )
                                                                                            }
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "修改"
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e()
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e()
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        !item.fix
                                                          ? [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col",
                                                                  staticStyle: {
                                                                    flex: "1",
                                                                    color:
                                                                      "rgba(41, 2, 2, 0.45)",
                                                                    "font-size":
                                                                      "14px"
                                                                  }
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticStyle: {
                                                                      width:
                                                                        "8px",
                                                                      height:
                                                                        "8px",
                                                                      "margin-right":
                                                                        "3px",
                                                                      "vertical-align":
                                                                        "middle"
                                                                    },
                                                                    attrs: {
                                                                      src: require("../../assets/images/x-icon.png")
                                                                    }
                                                                  }),
                                                                  _vm._v(
                                                                    "使用模板时，由模板发起人指定签署方\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col final"
                                                          },
                                                          [
                                                            _c(
                                                              "el-form-item",
                                                              [
                                                                _c(
                                                                  "el-checkbox",
                                                                  {
                                                                    staticStyle: {
                                                                      margin:
                                                                        "0"
                                                                    },
                                                                    attrs: {
                                                                      "true-label": 11,
                                                                      "false-label": null
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.authLevelChange(
                                                                          i
                                                                        )
                                                                      }
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        item.authLevel,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "authLevel",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "item.authLevel"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              需要人脸识别\n                            "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "el-tooltip",
                                                                  {
                                                                    attrs: {
                                                                      effect:
                                                                        "light",
                                                                      content:
                                                                        "",
                                                                      placement:
                                                                        "bottom-end"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        attrs: {
                                                                          slot:
                                                                            "content"
                                                                        },
                                                                        slot:
                                                                          "content"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                选择人脸识别，可把签署方的"
                                                                        ),
                                                                        _c(
                                                                          "br"
                                                                        ),
                                                                        _vm._v(
                                                                          "人脸视频文件作为签署证据\n                              "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "el-icon-question",
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "16px",
                                                                        color:
                                                                          "#a1a1a1",
                                                                        cursor:
                                                                          "pointer"
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _vm.signers
                                                                  .length > 1
                                                                  ? _c("span", {
                                                                      staticClass:
                                                                        "el-icon-delete",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.delSigner(
                                                                            item,
                                                                            i
                                                                          )
                                                                        }
                                                                      }
                                                                    })
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-dialog",
                          {
                            attrs: {
                              title: "提示",
                              visible: _vm.authLevelShow,
                              width: "20%"
                            },
                            on: {
                              "update:visible": function($event) {
                                _vm.authLevelShow = $event
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  "text-align": "center"
                                }
                              },
                              [
                                _vm._v(
                                  "是否取消该签署方的人脸识别？取消人脸识别，将不能把该签署方的人脸视频文件作为签署证据。"
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "dialog-footer",
                                attrs: { slot: "footer" },
                                slot: "footer"
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.authLevelShow = false
                                      }
                                    }
                                  },
                                  [_vm._v("取 消")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        _vm.dialogVisible = false
                                      }
                                    }
                                  },
                                  [_vm._v("确 定")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { staticClass: "text-center" },
            [
              _c(
                "el-button",
                {
                  staticClass: "abtn",
                  attrs: { type: "danger" },
                  on: { click: _vm.nextStep }
                },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择签署方",
            visible: _vm.showTel,
            "lock-scroll": "",
            width: "749px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showTel = $event
            }
          }
        },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTabSigner,
                callback: function($$v) {
                  _vm.activeTabSigner = $$v
                },
                expression: "activeTabSigner"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "常用签署方", name: "default" } },
                [
                  _c(
                    "el-row",
                    { staticClass: "tel-search" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              placeholder: "邮箱/手机号"
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.getTelList()
                              }
                            },
                            model: {
                              value: _vm.telPageInfo.accountNo,
                              callback: function($$v) {
                                _vm.$set(_vm.telPageInfo, "accountNo", $$v)
                              },
                              expression: "telPageInfo.accountNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6, offset: 1 } },
                        [
                          _c("el-input", {
                            attrs: { size: "small", placeholder: "签署方姓名" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.getTelList()
                              }
                            },
                            model: {
                              value: _vm.telPageInfo.name,
                              callback: function($$v) {
                                _vm.$set(_vm.telPageInfo, "name", $$v)
                              },
                              expression: "telPageInfo.name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6, offset: 1 } },
                        [
                          _c("el-input", {
                            attrs: { size: "small", placeholder: "证件号" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.getTelList()
                              }
                            },
                            model: {
                              value: _vm.telPageInfo.idNo,
                              callback: function($$v) {
                                _vm.$set(_vm.telPageInfo, "idNo", $$v)
                              },
                              expression: "telPageInfo.idNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 3, offset: 1 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "small" },
                              on: { click: _vm.getTelList }
                            },
                            [_vm._v("查询")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "tel-box",
                      staticStyle: {
                        "max-height": "340px",
                        overflow: "auto",
                        "min-width": "749px"
                      }
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.telList,
                            "highlight-current-row": "",
                            "tooltip-effect": "dark",
                            stripe: "",
                            "cell-style": { cursor: "pointer" },
                            "header-cell-style": {
                              background: "#f9f9f9",
                              color: "#333333",
                              fontWeight: "500"
                            }
                          },
                          on: { "row-click": _vm.handleTelRowClickSelectRow }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "签署方名称",
                              prop: "enterpriseName"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { label: "证件号", prop: "businessLicense" }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "邮箱/手机号",
                              prop: "mobileOrChild"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    staticStyle: {
                      "text-align": "right",
                      "margin-top": "10px"
                    },
                    attrs: {
                      "current-page": _vm.telPageInfo.itemPage,
                      "page-sizes": [6, 12, 30, 60],
                      "page-size": _vm.telPageInfo.pageSize,
                      layout: "sizes, prev, pager, next, jumper, total",
                      total: _vm.telPageInfo.total
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange
                    }
                  })
                ],
                1
              ),
              _vm.isGroup
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.activeTabOrganizationName,
                        name: "organization"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        { staticClass: "tel-search" },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 18 } },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { padding: "0 20px 0 0" },
                                      attrs: { span: 8 }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          size: "small",
                                          placeholder: "邮箱/手机号"
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.clickHandleMyCorpSearch()
                                          }
                                        },
                                        model: {
                                          value: _vm.myCorpModel.keyword,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.myCorpModel,
                                              "keyword",
                                              $$v
                                            )
                                          },
                                          expression: "myCorpModel.keyword"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { padding: "0 10px" },
                                      attrs: { span: 8 }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          size: "small",
                                          placeholder: "签署方名称"
                                        },
                                        model: {
                                          value: _vm.myCorpModel.corpUserName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.myCorpModel,
                                              "corpUserName",
                                              $$v
                                            )
                                          },
                                          expression: "myCorpModel.corpUserName"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { padding: "0 10px" },
                                      attrs: { span: 8 }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: "请选择部门",
                                            size: "small"
                                          },
                                          model: {
                                            value: _vm.myCorpModel.corpGroupId,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.myCorpModel,
                                                "corpGroupId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "myCorpModel.corpGroupId"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { label: "全部", value: "" }
                                          }),
                                          _vm._l(_vm.department, function(
                                            item,
                                            i
                                          ) {
                                            return _c("el-option", {
                                              key: i,
                                              attrs: {
                                                label: item.groupName,
                                                value: item.corpGroupId
                                              }
                                            })
                                          })
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 5, offset: 1 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.clickHandleMyCorpSearch()
                                    }
                                  }
                                },
                                [_vm._v("查询")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "tel-box",
                          staticStyle: { height: "415px", overflow: "auto" }
                        },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.myCorpModel.loading,
                                  expression: "myCorpModel.loading"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: {
                                "empty-text": _vm.myCorpModel.emptyText,
                                data: _vm.tableListMyCorp,
                                "highlight-current-row": "",
                                "tooltip-effect": "dark",
                                stripe: "",
                                "cell-style": { cursor: "pointer" },
                                "header-cell-style": {
                                  background: "#f9f9f9",
                                  color: "#333333",
                                  fontWeight: "500"
                                }
                              },
                              on: { "row-click": _vm.handleRowClickMyCorp }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "邮箱/手机号",
                                  prop: "targetId"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "签署方名称", prop: "userName" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "部门", prop: "groupNames" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("br"),
                      _c("el-pagination", {
                        staticStyle: { "text-align": "right" },
                        attrs: {
                          "current-page": _vm.myCorpModel.itemPage,
                          "page-sizes": [10, 20, 50, 100],
                          "page-size": _vm.myCorpModel.pageSize,
                          layout: "sizes, prev, pager, next, jumper, total",
                          total: _vm.myCorpModel.total
                        },
                        on: {
                          "size-change": _vm.handleSizeChangeQueryToolMyCorp,
                          "current-change":
                            _vm.handleCurrentChangeQueryToolMyCorp
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "p",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "danger", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.handleClickSelectSignorOk()
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "模板授权范围",
            visible: _vm.visibleMoveOrg,
            top: "25vh",
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleMoveOrg = $event
            }
          }
        },
        [
          _c("el-tree", {
            ref: "referenceMoveTree",
            staticClass: "tree-style",
            attrs: {
              data: _vm.treeGroupCopy,
              "check-on-click-node": "",
              "expand-on-click-node": false,
              "check-strictly": true,
              "node-key": "corpGroupId",
              props: _vm.defaultProps,
              "show-checkbox": "",
              "default-expand-all": ""
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.visibleMoveOrg = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getCheckedNodes()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("sign-info-tips-dialog", {
        attrs: {
          show: _vm.visibleCredit,
          entCreditArr: _vm.entCreditArr,
          entCreditJson: _vm.entCreditJson,
          userIdentityInfoArr: _vm.userIdentityInfoArr,
          sureText: "确认无误"
        },
        on: {
          "update:show": function($event) {
            _vm.visibleCredit = $event
          },
          continue: _vm.addContractById,
          cancel: _vm.handleDelSendContract
        }
      }),
      _c(
        "el-dialog",
        {
          staticClass: "com-myDialog",
          attrs: {
            title: "提示",
            visible: _vm.tipsDialogVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.tipsDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "con" }, [
            _c("p", { staticStyle: { "margin-top": "40px" } }, [
              _c("span", { staticClass: "el-icon-warning" }),
              _vm._v("当前内容还未保存，确认退出编辑？\n      ")
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      ;(_vm.tipsDialogVisible = false), (_vm.sureEdit = false)
                    }
                  }
                },
                [_vm._v("继续填写")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmEdit } },
                [_vm._v("仍然退出")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bbb0ea1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bbb0ea1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/advancedVersion/addTpl.vue
// module id = TXln
// module chunks = 46